// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getOrderState, OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import displayOrder from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/DisplayOrder";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    let orderNumber;
    let email;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ orderNumber: string; sTEmail?: string }>(location.search);
        orderNumber = parsedQuery.orderNumber;
        email = parsedQuery.sTEmail || "";
    }
    return {
        orderNumber,
        email,
        orderState: getOrderState(state, orderNumber),
        isGuestUser: getCurrentUserIsGuest(state),
    };
};

const mapDispatchToProps = {
    displayOrder,
};
type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RequestRmaSuccessPage = ({ id, orderNumber, orderState, isGuestUser, email, displayOrder }: Props) => {
    React.useEffect(() => {
        if (orderNumber && email && isGuestUser) {
            displayOrder({ orderNumber, sTEmail: email } as any);
        }
        if (orderNumber && !isGuestUser) {
            displayOrder({ orderNumber });
        }
    }, []);

    return (
        <Page data-test-selector="RequestRmaSuccessPage">
            <OrderStateContext.Provider value={orderState}>
                <Zone contentId={id} zoneName="Content" />
            </OrderStateContext.Provider>
        </Page>
    );
};
const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestRmaSuccessPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};
export default pageModule;
